import { clearSelectedPatient } from "../store/slices/selectedPatientSlice";
import { removeTempPatientId } from "./openPatientTab";

export const convertInchesToFeetInches = (heightInInches) => {
  if (heightInInches == null) return null;

  // Normalize input
  let inchesValue;

  if (typeof heightInInches === "number") {
    inchesValue = heightInInches;
  } else if (typeof heightInInches === "string") {
    inchesValue = parseFloat(heightInInches); // handles "70", "70in", "70 inches"
  }

  if (isNaN(inchesValue)) return null;

  const feet = Math.floor(inchesValue / 12);
  const inches = Math.round(inchesValue % 12); // round for decimals

  return {
    feet,
    inches,
    formatted: `${feet}'${inches}"`,
  };
};

export const formatBmi = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const bmi = String(value)
    .replace(/[^0-9.]/g, "")
    .replace(/(\..*)\./g, "$1");

  return Math.round(Number(bmi));
};

export const calculateBMI = (bmiState) => {
  if (!bmiState) {
    return null;
  }

  const height =
    parseInt(bmiState?.heightFeet) * 12 + parseInt(bmiState?.heightInches);

  if (
    !height ||
    height <= 0 ||
    !bmiState?.patWeight ||
    bmiState?.patWeight <= 0
  ) {
    return null;
  }

  const bmi = Math.round((bmiState?.patWeight * 703) / Math.pow(height, 2));

  return !isNaN(bmi) ? bmi : null;
};

export const clearPatientData = (dispatch, callDispatch = true) => {
  if (callDispatch) {
    dispatch(clearSelectedPatient());
  }

  sessionStorage.removeItem("patientId");
  removeTempPatientId();
};
